/** Release speed (px/ms) treated as a flick toward the next detent. */
export const FLICK_VELOCITY = 0.5;
/**
 * Released below this fraction of the lowest detent, a drawer closes. Just under 1, so dragging
 * below the lowest detent closes it, while a few pixels of wobble when grabbing the handle don't.
 */
export const CLOSE_RATIO = 0.85;

/**
 * Picks the height a drawer should settle at when a drag ends, or null to close it.
 * @param height current height (px)
 * @param velocity release velocity (px/ms); positive means the drawer was growing
 * @param detents resting heights (px), ascending
 */
export function resolveDetent(height: number, velocity: number, detents: readonly number[]): number | null {
    if (velocity > FLICK_VELOCITY) {
        return detents.find((detent) => detent > height) ?? detents[detents.length - 1];
    }
    if (velocity < -FLICK_VELOCITY) {
        return [...detents].reverse().find((detent) => detent < height) ?? null;
    }
    if (height < detents[0] * CLOSE_RATIO) return null;
    return detents.reduce((nearest, detent) => Math.abs(detent - height) < Math.abs(nearest - height) ? detent : nearest);
}
